import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export const useQueryKisiBrandConfig = ({ api }: { api: ApiType }) =>
  useQuery({
    queryKey: kisiQueryKeys.brandConfig(),
    queryFn: async () => (await api.kisiApi.brandConfig()).data,
  });
